import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import settings from 'configs/settings';
import App from 'App';

//Import stylesheets
import 'assets/css/common.min.css';
import 'assets/css/bootstrap-grid.min.css'; 
import 'assets/fonts/fontawesome/fontawesome-all.min.css'; 

ReactDOM.render(
  <Router basename='/' /* basename={ "/csango" } */>
    <App />
  </Router>,
  document.getElementById('root')
);
